<template>
  <div class="settings">
    <v-container class="pt-10">
      <v-row class="py-2 px-3 pt-1">
        <v-responsive class="overflow-visible">
          <h1 class="subheading grey--text">Users</h1>
        </v-responsive>
        <v-text-field
          label="Email"
          v-model="emailToSearch"
          outlined
          v-on:keyup.enter="searchUser(emailToSearch)"
        ></v-text-field>
        <v-btn dark class="primary" @click.stop="searchUser(emailToSearch)">
          Search
        </v-btn>
      </v-row>
      <v-row align="start" justify="start">
        <v-col cols="12" sm="12" md="12">
          <!-- <p v-if="usersFound">{{usersFound}}</p> -->
          <v-data-table
            v-if="usersFound"
            :headers="headers"
            :items="usersFound"
            :search="search"
            class="app_background"
            @click:row="seeUserDetails"
          ></v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { usersCollection } from "@/plugins/firebase.js";

export default {
  name: "Users",
  title: "Users",

  data() {
    return {
      show: false,
      search: "",
      headers: [
        {
          text: "EMAIL",
          align: "start",
          sortable: true,
          value: "email",
        },
        { text: "NAME", value: "name" },
        { text: "ID", value: "id" },
      ],
      emailToSearch: "",
      usersFound: [],
    };
  },
  computed: {
    loadedPosts() {
      return this.$store.getters.loadedPosts;
    },
  },
  methods: {
    seeUserDetails(value) {
      this.$router.push(`/users/${value.id}`);
    },
    async searchUser(email) {
      const usersFound = [];
      await usersCollection
        .orderBy("email")
        .startAt(email)
        .endAt(email + "\uf8ff")
        .limit(10)
        .get()
        .then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            let singleuser = doc.data();
            singleuser.id = doc.id;
            usersFound.push(singleuser);
          });
        })
        .catch((err) => console.log(err));
      this.usersFound = usersFound;
    },
  },
};
</script>

<style>
</style>